<ng-container *ngIf="data">
    <div [@openClose]="isOpen ? 'open' : 'close'" class="more-info">
        <div class="units">
            <ng-container *ngFor="let unit of data.graphs | keyvalue: originalOrder">
                <button class="unit-button" *ngIf="data.graphs[unit.key]" (click)="selectUnit(unit.key)"
                    [ngClass]="{
                        'selected': currentUnit === unit.key,
                        'compare': data.fields[selectedColumn][unit.key].salesCompare,
                        'down-gesture': data.fields[selectedColumn][unit.key].positive < 0,
                        'up-gesture': data.fields[selectedColumn][unit.key].positive > 0
                    }">
                    <span class="title">{{salesUnits[unit.key]}}</span>
                    <span class="sales">{{data.fields[selectedColumn][unit.key].sales}}</span>
                    <span class="sales compare" *ngIf="data.fields[selectedColumn][unit.key].salesCompare">{{data.fields[selectedColumn][unit.key].salesCompare}}</span>
                </button>
            </ng-container>
        </div>
        <app-vertical-bar-graph *ngIf="data.graphs[currentUnit]" 
            [graph]="data.graphs[currentUnit]" 
            [selectedColumnIndex]="selectedColumn"
            (onBarSelect)="onSelectGarphValue($event)"
        >
        </app-vertical-bar-graph>
    </div>

    <div class="toggle-wrapper" [ngClass]="{'open': isOpen }">
        <button type="button" (click)="toggleMoreInfo()" class="more-info-button">
            <img [src]="isOpen ? './assets/icons/chevron-up.svg' : './assets/icons/chevron-down.svg'"
                [alt]="isOpen ? 'open' : 'close'" />
        </button>
    </div>
</ng-container>